module.exports = __webpack_public_path__ + "img/avatar.6ac83a32.png";